export enum BuildingTypeOfUse {
    OFFICE = 'OFFICE',
    RETAIL = 'RETAIL',
    HEALTH_CARE = 'HEALTH_CARE',
    HOTELS_HOSPITALITY = 'HOTELS_HOSPITALITY',
    INDUSTRIES_LOGISTICS = 'INDUSTRIES_LOGISTICS',
    GASTRONOMY = 'GASTRONOMY',
    RESIDENTIAL_PROPERTY = 'RESIDENTIAL_PROPERTY',
}
